import styled from '@emotion/styled'
import {theme} from '../../../../theme'

export const FormCard = styled.div`
  border: 1px solid ${theme.colors.border.default};
  border-radius: ${theme.radii.xl};
  margin-bottom: ${theme.space[1]};
`

export const FormHeader = styled.div`
  border-bottom: 1px solid ${theme.colors.border.default};
  padding: ${theme.space[5]};
`

export const FormBody = styled.div`
  padding: ${theme.space[5]};
`

export const TypeBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${theme.space[1]};
  padding: 5px ${theme.space[3]};
  border-radius: ${theme.radii.full};
  background: ${theme.colors.status.info.bg};
  color: ${theme.colors.status.info.text};
  font-size: ${theme.fontSizes.md};
  font-weight: ${theme.fontWeights.medium};

  svg {
    flex-shrink: 0;
  }
`
